module.exports = __webpack_public_path__ + "img/login.48b7cfe7.svg";